export const getSortLabelKey = (sortId, options) => {
	return options.find(option => option.id === sortId)?.labelKey;
};
